function F(r, t) {
  (t == null || t > r.length) && (t = r.length);
  for (var e = 0, n = Array(t); e < t; e++) n[e] = r[e];
  return n;
}
function ie(r) {
  if (Array.isArray(r)) return r;
}
function Y(r, t, e, n, i, a, s) {
  try {
    var l = r[a](s), o = l.value;
  } catch (c) {
    return void e(c);
  }
  l.done ? t(o) : Promise.resolve(o).then(n, i);
}
function G(r) {
  return function() {
    var t = this, e = arguments;
    return new Promise(function(n, i) {
      var a = r.apply(t, e);
      function s(o) {
        Y(a, n, i, s, l, "next", o);
      }
      function l(o) {
        Y(a, n, i, s, l, "throw", o);
      }
      s(void 0);
    });
  };
}
function z(r, t) {
  if (!(r instanceof t)) throw new TypeError("Cannot call a class as a function");
}
function re(r, t) {
  for (var e = 0; e < t.length; e++) {
    var n = t[e];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(r, Z(n.key), n);
  }
}
function K(r, t, e) {
  return t && re(r.prototype, t), Object.defineProperty(r, "prototype", {
    writable: !1
  }), r;
}
function j(r, t) {
  var e = typeof Symbol < "u" && r[Symbol.iterator] || r["@@iterator"];
  if (!e) {
    if (Array.isArray(r) || (e = $(r)) || t) {
      e && (r = e);
      var n = 0, i = function() {
      };
      return {
        s: i,
        n: function() {
          return n >= r.length ? {
            done: !0
          } : {
            done: !1,
            value: r[n++]
          };
        },
        e: function(o) {
          throw o;
        },
        f: i
      };
    }
    throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  var a, s = !0, l = !1;
  return {
    s: function() {
      e = e.call(r);
    },
    n: function() {
      var o = e.next();
      return s = o.done, o;
    },
    e: function(o) {
      l = !0, a = o;
    },
    f: function() {
      try {
        s || e.return == null || e.return();
      } finally {
        if (l) throw a;
      }
    }
  };
}
function v(r, t, e) {
  return (t = Z(t)) in r ? Object.defineProperty(r, t, {
    value: e,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : r[t] = e, r;
}
function ae(r, t) {
  var e = r == null ? null : typeof Symbol < "u" && r[Symbol.iterator] || r["@@iterator"];
  if (e != null) {
    var n, i, a, s, l = [], o = !0, c = !1;
    try {
      if (a = (e = e.call(r)).next, t !== 0) for (; !(o = (n = a.call(e)).done) && (l.push(n.value), l.length !== t); o = !0) ;
    } catch (u) {
      c = !0, i = u;
    } finally {
      try {
        if (!o && e.return != null && (s = e.return(), Object(s) !== s)) return;
      } finally {
        if (c) throw i;
      }
    }
    return l;
  }
}
function se() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function M() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */
  var r, t, e = typeof Symbol == "function" ? Symbol : {}, n = e.iterator || "@@iterator", i = e.toStringTag || "@@toStringTag";
  function a(f, h, T, g) {
    var x = h && h.prototype instanceof l ? h : l, q = Object.create(x.prototype);
    return w(q, "_invoke", function(ee, ne, te) {
      var b, m, E, D = 0, B = te || [], P = !1, _ = {
        p: 0,
        n: 0,
        v: r,
        a: U,
        f: U.bind(r, 4),
        d: function(I, C) {
          return b = I, m = 0, E = r, _.n = C, s;
        }
      };
      function U(I, C) {
        for (m = I, E = C, t = 0; !P && D && !A && t < B.length; t++) {
          var A, R = B[t], H = _.p, V = R[2];
          I > 3 ? (A = V === C) && (E = R[(m = R[4]) ? 5 : (m = 3, 3)], R[4] = R[5] = r) : R[0] <= H && ((A = I < 2 && H < R[1]) ? (m = 0, _.v = C, _.n = R[1]) : H < V && (A = I < 3 || R[0] > C || C > V) && (R[4] = I, R[5] = C, _.n = V, m = 0));
        }
        if (A || I > 1) return s;
        throw P = !0, C;
      }
      return function(I, C, A) {
        if (D > 1) throw TypeError("Generator is already running");
        for (P && C === 1 && U(C, A), m = C, E = A; (t = m < 2 ? r : E) || !P; ) {
          b || (m ? m < 3 ? (m > 1 && (_.n = -1), U(m, E)) : _.n = E : _.v = E);
          try {
            if (D = 2, b) {
              if (m || (I = "next"), t = b[I]) {
                if (!(t = t.call(b, E))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                E = t.value, m < 2 && (m = 0);
              } else m === 1 && (t = b.return) && t.call(b), m < 2 && (E = TypeError("The iterator does not provide a '" + I + "' method"), m = 1);
              b = r;
            } else if ((t = (P = _.n < 0) ? E : ee.call(ne, _)) !== s) break;
          } catch (R) {
            b = r, m = 1, E = R;
          } finally {
            D = 1;
          }
        }
        return {
          value: t,
          done: P
        };
      };
    }(f, T, g), !0), q;
  }
  var s = {};
  function l() {
  }
  function o() {
  }
  function c() {
  }
  t = Object.getPrototypeOf;
  var u = [][n] ? t(t([][n]())) : (w(t = {}, n, function() {
    return this;
  }), t), d = c.prototype = l.prototype = Object.create(u);
  function p(f) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(f, c) : (f.__proto__ = c, w(f, i, "GeneratorFunction")), f.prototype = Object.create(d), f;
  }
  return o.prototype = c, w(d, "constructor", c), w(c, "constructor", o), o.displayName = "GeneratorFunction", w(c, i, "GeneratorFunction"), w(d), w(d, i, "Generator"), w(d, n, function() {
    return this;
  }), w(d, "toString", function() {
    return "[object Generator]";
  }), (M = function() {
    return {
      w: a,
      m: p
    };
  })();
}
function w(r, t, e, n) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch {
    i = 0;
  }
  w = function(a, s, l, o) {
    function c(u, d) {
      w(a, u, function(p) {
        return this._invoke(u, d, p);
      });
    }
    s ? i ? i(a, s, {
      value: l,
      enumerable: !o,
      configurable: !o,
      writable: !o
    }) : a[s] = l : (c("next", 0), c("throw", 1), c("return", 2));
  }, w(r, t, e, n);
}
function oe(r, t) {
  return ie(r) || ae(r, t) || $(r, t) || se();
}
function le(r, t) {
  if (typeof r != "object" || !r) return r;
  var e = r[Symbol.toPrimitive];
  if (e !== void 0) {
    var n = e.call(r, t);
    if (typeof n != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(r);
}
function Z(r) {
  var t = le(r, "string");
  return typeof t == "symbol" ? t : t + "";
}
function N(r) {
  "@babel/helpers - typeof";
  return N = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, N(r);
}
function $(r, t) {
  if (r) {
    if (typeof r == "string") return F(r, t);
    var e = {}.toString.call(r).slice(8, -1);
    return e === "Object" && r.constructor && (e = r.constructor.name), e === "Map" || e === "Set" ? Array.from(r) : e === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(e) ? F(r, t) : void 0;
  }
}
var X = "1.70.7", O = "__ZM_WEB_SERVICE_HUB_MSG__", ce = 1e3, ue = /* @__PURE__ */ function() {
  function r() {
    var t, e, n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    z(this, r), v(this, "actionBindings", /* @__PURE__ */ new Map()), v(this, "pendingCalls", /* @__PURE__ */ new Map()), v(this, "debug", void 0), v(this, "permissionChecker", void 0), v(this, "allowedDomains", void 0), v(this, "callTimeout", void 0), v(this, "sourceToProviderId", /* @__PURE__ */ new WeakMap()), v(this, "windowCloseListeners", /* @__PURE__ */ new Map()), v(this, "isMainApp", void 0), this.debug = (t = n.debug) !== null && t !== void 0 ? t : !1, this.permissionChecker = n.permissionChecker, this.allowedDomains = n.allowedDomains, this.callTimeout = (e = n.callTimeout) !== null && e !== void 0 ? e : 3e4, this.init();
  }
  return K(r, [{
    key: "init",
    value: function() {
      this.checkAndSetMainApp(), this.isMainApp && (this.listenMessages(), this.broadcastContainerReady());
    }
  }, {
    key: "checkAndSetMainApp",
    value: function() {
      var e = window.top === window && !window.__MICRO_APP_ENVIRONMENT__;
      e ? window.__ZM_WEB_SERVICE_HUB ? (this.isMainApp = !1, this.log("ServiceHub detected existing main app instance, running as secondary")) : (window.__ZM_WEB_SERVICE_HUB = this, this.isMainApp = !0, this.log("ServiceHub initialized as main app (service registration center)")) : (this.isMainApp = !1, this.log("ServiceHub in non-main app environment - running independently"));
    }
  }, {
    key: "listenMessages",
    value: function() {
      var e = this;
      window.addEventListener("message", function(n) {
        if (e.isValidMessage(n)) {
          var i = n.data[O];
          e.handleMessage(n, i);
        }
      }), window.addEventListener("beforeunload", function() {
        e.cleanup();
      });
    }
  }, {
    key: "isValidMessage",
    value: function(e) {
      var n = e.data;
      return !!n && N(n) === "object" && n[O] !== void 0 && n[O] !== null;
    }
  }, {
    key: "handleMessage",
    value: function(e, n) {
      var i = e.source;
      if (!(!n || N(n) !== "object" || !n.type)) {
        var a = i || window;
        switch (this.log("receive ", n, "from", a), n.type) {
          case "SERVICE_REGISTER":
            this.handleServiceRegistration(n, a);
            break;
          case "SERVICE_CALL":
            this.handleServiceCall(n, a);
            break;
          case "SERVICE_QUERY":
            this.handleServiceQuery(n, a);
            break;
          case "SERVICE_RESPONSE":
            this.handleServiceResponse(n);
            break;
          case "WAITING_CONTAINER_READY":
            this.handleWaitingContainerReady(n, a);
            break;
          case "SERVICE_UNREGISTER":
            this.handleServiceUnregister(n, a);
            break;
        }
      }
    }
  }, {
    key: "handleServiceRegistration",
    value: function(e, n) {
      var i = this, a = e.serviceName, s = e.actions, l = e.providerId, o = e.jsCallId, c = this.getOrigin(n);
      if (this.log("handleServiceRegistration", e), !a || !s || !Array.isArray(s)) {
        this.log("Invalid service registration:", e), o && this.sendToSource(n, {
          type: "SERVICE_REGISTER_RESPONSE",
          jsCallId: o,
          returnCode: -1,
          serviceName: a,
          errorMsg: "Invalid service registration parameters"
        });
        return;
      }
      var u = j(s), d;
      try {
        for (u.s(); !(d = u.n()).done; ) {
          var p = d.value;
          if (!p.name) {
            this.log("Invalid action in registration:", p), o && this.sendToSource(n, {
              type: "SERVICE_REGISTER_RESPONSE",
              jsCallId: o,
              returnCode: -1,
              serviceName: a,
              errorMsg: "Invalid action: ".concat(JSON.stringify(p))
            });
            return;
          }
        }
      } catch (f) {
        u.e(f);
      } finally {
        u.f();
      }
      try {
        s.forEach(function(f) {
          var h = "".concat(a, ".").concat(f.name), T = {
            serviceName: a,
            action: f.name,
            providerId: l,
            source: n,
            origin: c,
            registeredAt: Date.now()
          };
          i.actionBindings.set(h, T);
          var g = i.sourceToProviderId.get(n);
          g || (g = /* @__PURE__ */ new Set(), i.sourceToProviderId.set(n, g)), g.add(l), i.addWindowCloseListener(n, l), i.log("Action bound: ".concat(h, " by ").concat(l));
        }), this.notifyServiceChanged(), o && this.sendToSource(n, {
          type: "SERVICE_REGISTER_RESPONSE",
          jsCallId: o,
          returnCode: 0,
          serviceName: a
        });
      } catch (f) {
        this.log("Error during service registration:", f), o && this.sendToSource(n, {
          type: "SERVICE_REGISTER_RESPONSE",
          jsCallId: o,
          returnCode: -1,
          serviceName: a,
          errorMsg: f.message || "Service registration failed"
        });
      }
    }
  }, {
    key: "addWindowCloseListener",
    value: function(e, n) {
      var i = this;
      if (!this.windowCloseListeners.has(e)) {
        var a = function() {
          i.cleanupProvider(n), i.windowCloseListeners.delete(e);
        };
        try {
          e.addEventListener("beforeunload", a), this.windowCloseListeners.set(e, a);
        } catch {
          this.log("Cannot add beforeunload listener to cross-origin window");
        }
      }
    }
  }, {
    key: "cleanupProvider",
    value: function(e) {
      var n = j(this.actionBindings.entries()), i;
      try {
        for (n.s(); !(i = n.n()).done; ) {
          var a = oe(i.value, 2), s = a[0], l = a[1];
          l.providerId === e && this.actionBindings.delete(s);
        }
      } catch (p) {
        n.e(p);
      } finally {
        n.f();
      }
      var o = j(this.actionBindings.values()), c;
      try {
        for (o.s(); !(c = o.n()).done; ) {
          var u = c.value;
          if (u.providerId === e) {
            var d = this.sourceToProviderId.get(u.source);
            d && (d.delete(e), d.size === 0 && this.sourceToProviderId.delete(u.source));
            break;
          }
        }
      } catch (p) {
        o.e(p);
      } finally {
        o.f();
      }
      this.log("Provider ".concat(e, " cleaned up")), this.notifyServiceChanged();
    }
  }, {
    key: "handleServiceCall",
    value: function() {
      var t = G(/* @__PURE__ */ M().m(function n(i, a) {
        var s, l, o, c, u, d, p, f, h, T;
        return M().w(function(g) {
          for (; ; ) switch (g.p = g.n) {
            case 0:
              if (s = i.jsCallId, l = i.serviceName, o = i.action, c = i.params, u = this.getProviderId(a) || "unknown", d = this.getOrigin(a), p = "".concat(l, ".").concat(o), f = this.actionBindings.get(p), !(!l || !o)) {
                g.n = 1;
                break;
              }
              return this.sendError(
                a,
                s,
                "Invalid service call parameters, serviceName: ".concat(l, ", action: ").concat(o),
                1006
                /* INVALID_PARAMS */
              ), this.log("actionBindings", this.actionBindings.keys(), this.actionBindings.values), g.a(2);
            case 1:
              if (f) {
                g.n = 2;
                break;
              }
              return this.sendError(
                a,
                s,
                "Action not found: ".concat(p),
                1001
                /* SERVICE_NOT_FOUND */
              ), g.a(2);
            case 2:
              if (this.checkDomain(d)) {
                g.n = 3;
                break;
              }
              return this.sendError(
                a,
                s,
                "Domain not allowed: ".concat(d),
                1003
                /* DOMAIN_NOT_ALLOWED */
              ), g.a(2);
            case 3:
              if (!(this.permissionChecker && !this.permissionChecker(u, l, o, d))) {
                g.n = 4;
                break;
              }
              return this.sendError(
                a,
                s,
                "Permission denied: ".concat(u, " → ").concat(p),
                1002
                /* PERMISSION_DENIED */
              ), g.a(2);
            case 4:
              return g.p = 4, g.n = 5, this.forwardCall(f, o, c, u);
            case 5:
              h = g.v, this.sendToSource(a, {
                type: "SERVICE_RESPONSE",
                jsCallId: s,
                returnCode: 0,
                result: h
              }), g.n = 7;
              break;
            case 6:
              g.p = 6, T = g.v, this.sendError(
                a,
                s,
                T.message || "Call failed",
                1005
                /* NETWORK_ERROR */
              );
            case 7:
              return g.a(2);
          }
        }, n, this, [[4, 6]]);
      }));
      function e(n, i) {
        return t.apply(this, arguments);
      }
      return e;
    }()
  }, {
    key: "forwardCall",
    value: function(e, n, i, a) {
      var s = this;
      return new Promise(function(l, o) {
        var c = s.generateId();
        s.pendingCalls.set(c, {
          resolve: l,
          reject: o,
          timestamp: Date.now(),
          requesterId: a
        }), s.sendToSource(e.source, {
          type: "SERVICE_EXECUTE",
          jsCallId: c,
          serviceName: e.serviceName,
          action: n,
          params: i,
          requesterId: a
        }), setTimeout(function() {
          s.pendingCalls.has(c) && (s.pendingCalls.delete(c), o(new Error("Call timeout")));
        }, s.callTimeout);
      });
    }
  }, {
    key: "handleServiceQuery",
    value: function(e, n) {
      var i = this.getServices();
      this.sendToSource(n, {
        type: "SERVICE_QUERY_RESPONSE",
        jsCallId: e.jsCallId,
        services: i
      });
    }
  }, {
    key: "handleServiceResponse",
    value: function(e) {
      var n = this.pendingCalls.get(e.jsCallId);
      n && (this.pendingCalls.delete(e.jsCallId), e.returnCode === 0 ? n.resolve(e.result) : n.reject(new Error(e.errorMsg || "Remote call failed")));
    }
  }, {
    key: "handleWaitingContainerReady",
    value: function(e, n) {
      this.sendToSource(n, {
        type: "CONTAINER_READY"
      });
    }
  }, {
    key: "handleServiceUnregister",
    value: function(e, n) {
      var i = e.providerId;
      this.log("Service unregister request from provider: ".concat(i)), this.cleanupProvider(i), this.sendToSource(n, {
        type: "SERVICE_UNREGISTER_CONFIRMED"
      });
    }
  }, {
    key: "broadcastContainerReady",
    value: function() {
      var e = this;
      setTimeout(function() {
        var n = {
          type: "CONTAINER_READY"
        };
        e.broadcastToAllFrames(n), e.sendToSource(window, n);
      }, ce);
    }
  }, {
    key: "broadcastToAllFrames",
    value: function(e) {
      var n = this, i = /* @__PURE__ */ new Set();
      try {
        for (var a = 0; a < window.frames.length; a++) {
          var s = window.frames[a];
          i.has(s) || (this.sendToSource(s, e), i.add(s));
        }
      } catch {
        this.log("Cross-origin access blocked when using window.frames");
      }
      var l = document.querySelectorAll("iframe");
      l.forEach(function(o) {
        o.contentWindow && !i.has(o.contentWindow) && (n.sendToSource(o.contentWindow, e), i.add(o.contentWindow));
      });
    }
  }, {
    key: "notifyServiceChanged",
    value: function() {
      var e = this.getServices(), n = {
        type: "SERVICE_CHANGED",
        services: e
      };
      this.broadcastToAllFrames(n), this.sendToSource(window, n), this.log("Notified all clients of service changes");
    }
  }, {
    key: "sendToSource",
    value: function(e, n) {
      try {
        var i = v({}, O, n), a = this.getOrigin(e);
        e.postMessage(i, a);
      } catch {
        try {
          var s = v({}, O, n);
          e.postMessage(s, "*");
        } catch (o) {
          this.log("Failed to send message:", o);
        }
      }
    }
  }, {
    key: "sendError",
    value: function(e, n, i) {
      var a = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 1005;
      this.sendToSource(e, {
        type: "SERVICE_RESPONSE",
        jsCallId: n,
        returnCode: a,
        errorMsg: i
      });
    }
  }, {
    key: "getProviderId",
    value: function(e) {
      var n = this.sourceToProviderId.get(e);
      if (!(!n || n.size === 0))
        return Array.from(n)[0];
    }
  }, {
    key: "getOrigin",
    value: function(e) {
      try {
        return e.location.origin;
      } catch {
        return window.location.origin;
      }
    }
  }, {
    key: "checkDomain",
    value: function(e) {
      return !this.allowedDomains || this.allowedDomains.length === 0 ? !0 : this.allowedDomains.some(function(n) {
        if (n === e) return !0;
        if (n.startsWith("*.")) {
          var i = n.slice(2);
          return e.endsWith("." + i) || e === i;
        }
        return !1;
      });
    }
  }, {
    key: "generateId",
    value: function() {
      return "id_".concat(Date.now(), "_").concat(Math.random().toString(36).substr(2, 9));
    }
  }, {
    key: "getServices",
    value: function() {
      var e = /* @__PURE__ */ new Map(), n = j(this.actionBindings.values()), i;
      try {
        var a = function() {
          var l = i.value, o = l.serviceName, c = l.providerId;
          e.has(o) || e.set(o, {
            serviceName: o,
            actions: [],
            providerId: c
          });
          var u = e.get(o);
          u.actions.some(function(d) {
            return d.name === l.action;
          }) || u.actions.push({
            name: l.action
          });
        };
        for (n.s(); !(i = n.n()).done; )
          a();
      } catch (s) {
        n.e(s);
      } finally {
        n.f();
      }
      return Array.from(e.values());
    }
  }, {
    key: "getServiceStatus",
    value: function() {
      return {
        services: this.getServices(),
        pendingCalls: this.pendingCalls.size
      };
    }
  }, {
    key: "isMainAppInstance",
    value: function() {
      return this.isMainApp;
    }
  }, {
    key: "cleanup",
    value: function() {
      this.pendingCalls.forEach(function(e) {
        return e.reject(new Error("Hub shutdown"));
      }), this.pendingCalls.clear(), this.actionBindings.clear(), this.windowCloseListeners.forEach(function(e) {
        return e();
      }), this.windowCloseListeners.clear(), this.sourceToProviderId = /* @__PURE__ */ new WeakMap(), this.isMainApp && window.__ZM_WEB_SERVICE_HUB === this && (window.__ZM_WEB_SERVICE_HUB = null);
    }
  }, {
    key: "log",
    value: function() {
      if (this.debug) {
        for (var e, n = (/* @__PURE__ */ new Date()).toISOString(), i = arguments.length, a = new Array(i), s = 0; s < i; s++)
          a[s] = arguments[s];
        (e = console).log.apply(e, ["[".concat(n, "] [v").concat(X, "] [WebServiceHub]")].concat(a));
      }
    }
  }]);
}(), L = "__ZM_WEB_SERVICE_HUB_MSG__", de = 3e4, ve = 1e4, fe = 5e3, Q = 3, he = /* @__PURE__ */ function() {
  function r(t) {
    var e, n, i, a = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    z(this, r), v(this, "providerId", void 0), v(this, "actionHandlers", /* @__PURE__ */ new Map()), v(this, "serviceActions", /* @__PURE__ */ new Map()), v(this, "pendingCalls", /* @__PURE__ */ new Map()), v(this, "isContainerReady", !1), v(this, "debug", void 0), v(this, "eventListeners", /* @__PURE__ */ new Map()), v(this, "pendingRegistrations", /* @__PURE__ */ new Map()), v(this, "callTimeout", void 0), v(this, "queryTimeout", void 0), v(this, "containerReadyTimeout", void 0), v(this, "retryAttempts", 0), v(this, "connectionStatus", "connecting"), v(this, "messageListener", void 0), v(this, "beforeUnloadListener", void 0), this.providerId = t, this.debug = (e = a.debug) !== null && e !== void 0 ? e : !1, this.callTimeout = (n = a.callTimeout) !== null && n !== void 0 ? n : de, this.queryTimeout = (i = a.queryTimeout) !== null && i !== void 0 ? i : ve, this.init();
  }
  return K(r, [{
    key: "init",
    value: function() {
      var e = this;
      this.messageListener = function(n) {
        if (e.isValidMessage(n)) {
          var i = n.data[L];
          e.handleMessage(i);
        }
      }, window.addEventListener("message", this.messageListener), this.beforeUnloadListener = function() {
        e.cleanup();
      }, window.addEventListener("beforeunload", this.beforeUnloadListener), this.requestContainerReady(), this.startContainerReadyTimeout();
    }
  }, {
    key: "detectEnvironment",
    value: function() {
      return window.top !== window ? "iframe" : window.__MICRO_APP_ENVIRONMENT__ ? "micro-app" : "main-app";
    }
  }, {
    key: "startContainerReadyTimeout",
    value: function() {
      var e = this;
      this.containerReadyTimeout = setTimeout(function() {
        e.isContainerReady || (e.log("Container ready timeout, retrying..."), e.retryConnection());
      }, fe);
    }
  }, {
    key: "retryConnection",
    value: function() {
      if (this.retryAttempts >= Q) {
        this.connectionStatus = "disconnected", this.emit("connectionFailed", new Error("Max retry attempts reached"));
        return;
      }
      this.retryAttempts++, this.log("Retrying connection attempt ".concat(this.retryAttempts, "/").concat(Q)), this.containerReadyTimeout && clearTimeout(this.containerReadyTimeout), this.requestContainerReady(), this.startContainerReadyTimeout();
    }
  }, {
    key: "isValidMessage",
    value: function(e) {
      var n = e.data;
      return !!n && N(n) === "object" && n[L] !== void 0 && n[L] !== null;
    }
  }, {
    key: "handleMessage",
    value: function(e) {
      if (!(!e || N(e) !== "object" || !e.type))
        switch (this.log(e), e.type) {
          case "CONTAINER_READY":
            this.handleContainerReady();
            break;
          case "SERVICE_EXECUTE":
            this.handleServiceExecute(e);
            break;
          case "SERVICE_RESPONSE":
            this.handleServiceResponse(e);
            break;
          case "SERVICE_QUERY_RESPONSE":
            this.handleServiceQueryResponse(e);
            break;
          case "SERVICE_CHANGED":
            this.handleServiceChanged(e);
            break;
          case "SERVICE_UNREGISTER_CONFIRMED":
            this.handleServiceUnregisterConfirmed();
            break;
          case "SERVICE_REGISTER_RESPONSE":
            this.handleServiceRegisterResponse(e);
            break;
        }
    }
  }, {
    key: "handleContainerReady",
    value: function() {
      var e = this;
      if (this.isContainerReady) {
        this.log("Container already ready");
        return;
      }
      this.isContainerReady = !0, this.connectionStatus = "connected", this.retryAttempts = 0, this.containerReadyTimeout && (clearTimeout(this.containerReadyTimeout), this.containerReadyTimeout = void 0), this.log("Container ready"), this.pendingRegistrations.forEach(function(n, i) {
        e.serviceActions.set(i, n.actions), n.actions.forEach(function(a) {
          if (a.handler) {
            var s = "".concat(i, ".").concat(a.name);
            e.actionHandlers.set(s, a.handler);
          }
        }), e.registerServiceWithContainer(i);
      }), this.pendingRegistrations.clear(), this.emit("containerReady");
    }
  }, {
    key: "handleServiceExecute",
    value: function() {
      var t = G(/* @__PURE__ */ M().m(function n(i) {
        var a, s, l, o, c, u, d, p, f;
        return M().w(function(h) {
          for (; ; ) switch (h.p = h.n) {
            case 0:
              if (a = i.jsCallId, s = i.serviceName, l = i.action, o = i.params, c = i.requesterId, this.log("handleServiceExecute", i), u = "".concat(s, ".").concat(l), this.actionHandlers.has(u)) {
                h.n = 1;
                break;
              }
              return h.a(2);
            case 1:
              if (d = this.actionHandlers.get(u), d) {
                h.n = 2;
                break;
              }
              return this.sendResponse(a, -1, void 0, "Action not found: ".concat(s, ".").concat(l)), h.a(2);
            case 2:
              return h.p = 2, h.n = 3, d(o, c);
            case 3:
              p = h.v, this.sendResponse(a, 0, p), h.n = 5;
              break;
            case 4:
              h.p = 4, f = h.v, this.sendResponse(a, -1, void 0, f.message || "Unknown error");
            case 5:
              return h.a(2);
          }
        }, n, this, [[2, 4]]);
      }));
      function e(n) {
        return t.apply(this, arguments);
      }
      return e;
    }()
  }, {
    key: "sendResponse",
    value: function(e, n, i, a) {
      this.sendToContainer({
        type: "SERVICE_RESPONSE",
        jsCallId: e,
        returnCode: n,
        result: i,
        errorMsg: a
      });
    }
  }, {
    key: "handleServiceResponse",
    value: function(e) {
      var n = this.pendingCalls.get(e.jsCallId);
      n && (this.pendingCalls.delete(e.jsCallId), e.returnCode === 0 ? n.resolve(e.result) : n.reject(new Error(e.errorMsg || "Service call failed")));
    }
  }, {
    key: "handleServiceQueryResponse",
    value: function(e) {
      var n = this.pendingCalls.get(e.jsCallId);
      n && (this.pendingCalls.delete(e.jsCallId), n.resolve(e.services));
    }
  }, {
    key: "handleServiceChanged",
    value: function(e) {
      this.log("Services changed:", e.services), this.emit("serviceChanged", e.services);
    }
  }, {
    key: "handleServiceUnregisterConfirmed",
    value: function() {
      this.log("Service unregister confirmed by hub"), this.emit("serviceUnregisterConfirmed");
    }
  }, {
    key: "handleServiceRegisterResponse",
    value: function(e) {
      var n = this.pendingCalls.get(e.jsCallId);
      n && (this.pendingCalls.delete(e.jsCallId), e.returnCode === 0 ? (this.log("Service registered successfully: ".concat(e.serviceName)), n.resolve(void 0)) : n.reject(new Error(e.errorMsg || "Service registration failed")));
    }
  }, {
    key: "destroy",
    value: function() {
      var e = this;
      return new Promise(function(n) {
        e.log("Destroying ServiceClient...");
        var i = !1, a = function(c) {
          i || (i = !0, l && clearTimeout(l), e.off("serviceUnregisterConfirmed", s), e.log("Service destroy completed: ".concat(c)), e.performCleanup(), n());
        };
        e.sendToContainer({
          type: "SERVICE_UNREGISTER",
          providerId: e.providerId
        });
        var s = function() {
          a("confirmed by hub");
        };
        e.on("serviceUnregisterConfirmed", s);
        var l = setTimeout(function() {
          a("timeout");
        }, 1e3);
      });
    }
  }, {
    key: "performCleanup",
    value: function() {
      this.log("Performing cleanup..."), this.pendingCalls.forEach(function(e) {
        try {
          e.reject(new Error("ServiceClient destroyed"));
        } catch (n) {
          console.warn("Error during ServiceClient cleanup:", n);
        }
      }), this.pendingCalls.clear(), this.actionHandlers.clear(), this.serviceActions.clear(), this.pendingRegistrations.clear(), this.containerReadyTimeout && (clearTimeout(this.containerReadyTimeout), this.containerReadyTimeout = void 0), this.eventListeners.clear(), this.messageListener && (window.removeEventListener("message", this.messageListener), this.messageListener = void 0), this.beforeUnloadListener && (window.removeEventListener("beforeunload", this.beforeUnloadListener), this.beforeUnloadListener = void 0), this.connectionStatus = "disconnected", this.log("ServiceClient destroyed");
    }
  }, {
    key: "registerService",
    value: function(e, n) {
      var i = this;
      if (!e)
        return Promise.reject(new Error("Invalid service name"));
      if (!Array.isArray(n))
        return Promise.reject(new Error("Actions must be an array"));
      var a = j(n), s;
      try {
        for (a.s(); !(s = a.n()).done; ) {
          var l = s.value;
          if (!l.name)
            return Promise.reject(new Error("Action must have a name"));
          if (!l.handler || typeof l.handler != "function")
            return Promise.reject(new Error("Action ".concat(l.name, " must have a handler function")));
        }
      } catch (o) {
        a.e(o);
      } finally {
        a.f();
      }
      return new Promise(function(o, c) {
        var u = function() {
          i.serviceActions.set(e, n), n.forEach(function(h) {
            var T = "".concat(e, ".").concat(h.name);
            i.actionHandlers.set(T, h.handler);
          });
          var f = i.generateId();
          i.pendingCalls.set(f, {
            resolve: o,
            reject: c,
            timestamp: Date.now(),
            requesterId: i.providerId
          }), i.registerServiceWithContainer(e, f), setTimeout(function() {
            i.pendingCalls.has(f) && (i.pendingCalls.delete(f), c(new Error("Service registration timeout (15s)")));
          }, 15e3);
        };
        if (i.isContainerReady)
          u(), i.log("Service registration started: ".concat(e));
        else {
          i.pendingRegistrations.set(e, {
            actions: n
          }), i.log("Service registration pending: ".concat(e));
          var d = function() {
            i.off("containerReady", d), u();
          };
          i.on("containerReady", d);
        }
      });
    }
  }, {
    key: "registerServiceWithContainer",
    value: function(e, n) {
      var i = this.serviceActions.get(e) || [], a = i.map(function(s) {
        return {
          name: s.name,
          description: s.description
        };
      });
      this.sendToContainer({
        type: "SERVICE_REGISTER",
        serviceName: e,
        actions: a,
        providerId: this.providerId,
        jsCallId: n
      });
    }
  }, {
    key: "callAction",
    value: function(e, n) {
      var i = this, a = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
      return e ? n ? new Promise(function(s, l) {
        var o = i.generateId();
        i.pendingCalls.set(o, {
          resolve: s,
          reject: l,
          timestamp: Date.now(),
          requesterId: i.providerId
        }), i.sendToContainer({
          type: "SERVICE_CALL",
          jsCallId: o,
          serviceName: e,
          action: n,
          params: a
        }), i.callTimeout > 0 && setTimeout(function() {
          i.pendingCalls.has(o) && (i.pendingCalls.delete(o), l(new Error("Service call timeout")));
        }, i.callTimeout);
      }) : Promise.reject(new Error("Invalid action name")) : Promise.reject(new Error("Invalid service name"));
    }
  }, {
    key: "queryServices",
    value: function() {
      var e = this;
      return new Promise(function(n, i) {
        var a = e.generateId();
        e.pendingCalls.set(a, {
          resolve: n,
          reject: i,
          timestamp: Date.now(),
          requesterId: e.providerId
        }), e.sendToContainer({
          type: "SERVICE_QUERY",
          jsCallId: a
        }), e.queryTimeout > 0 && setTimeout(function() {
          e.pendingCalls.has(a) && (e.pendingCalls.delete(a), i(new Error("Service query timeout")));
        }, e.queryTimeout);
      });
    }
  }, {
    key: "sendToContainer",
    value: function(e) {
      try {
        var n = this.detectEnvironment();
        if (n === "main-app") {
          var i = v({}, L, e);
          window.postMessage(i, "*");
        } else {
          var a = window.top;
          if (!a) {
            this.log("No top window available");
            return;
          }
          var s = v({}, L, e);
          a.postMessage(s, "*");
        }
      } catch (l) {
        this.log("Failed to send to container:", l);
      }
    }
  }, {
    key: "generateId",
    value: function() {
      return "id_".concat(Date.now(), "_").concat(Math.random().toString(36).substr(2, 9));
    }
  }, {
    key: "cleanup",
    value: function() {
      this.pendingCalls.forEach(function(e) {
        return e.reject(new Error("Client shutting down"));
      }), this.pendingCalls.clear(), this.actionHandlers.clear(), this.serviceActions.clear(), this.pendingRegistrations.clear(), this.containerReadyTimeout && (clearTimeout(this.containerReadyTimeout), this.containerReadyTimeout = void 0), this.eventListeners.clear(), this.messageListener && (window.removeEventListener("message", this.messageListener), this.messageListener = void 0), this.beforeUnloadListener && (window.removeEventListener("beforeunload", this.beforeUnloadListener), this.beforeUnloadListener = void 0);
    }
  }, {
    key: "log",
    value: function() {
      if (this.debug) {
        for (var e, n = (/* @__PURE__ */ new Date()).toISOString(), i = arguments.length, a = new Array(i), s = 0; s < i; s++)
          a[s] = arguments[s];
        (e = console).log.apply(e, ["[".concat(n, "] [v").concat(X, "] [WebServiceHub client ").concat(this.providerId, "]")].concat(a));
      }
    }
  }, {
    key: "on",
    value: function(e, n) {
      if (typeof e != "string" || !e.trim() || typeof n != "function")
        throw new Error("Invalid event or listener");
      var i = this.eventListeners.get(e) || [];
      i.push(n), this.eventListeners.set(e, i);
    }
  }, {
    key: "off",
    value: function(e, n) {
      if (!(typeof e != "string" || typeof n != "function")) {
        var i = this.eventListeners.get(e);
        if (i) {
          var a = i.indexOf(n);
          a > -1 && i.splice(a, 1);
        }
      }
    }
  }, {
    key: "once",
    value: function(e, n) {
      var i = this;
      if (typeof e != "string" || typeof n != "function")
        throw new Error("Invalid event or listener");
      var a = function() {
        i.off(e, a), n.apply(void 0, arguments);
      };
      this.on(e, a);
    }
  }, {
    key: "emit",
    value: function(e) {
      for (var n = this, i = arguments.length, a = new Array(i > 1 ? i - 1 : 0), s = 1; s < i; s++)
        a[s - 1] = arguments[s];
      var l = this.eventListeners.get(e) || [];
      l.forEach(function(o) {
        try {
          o.apply(void 0, a);
        } catch (c) {
          n.log("Event listener error:", c);
        }
      });
    }
  }, {
    key: "isReady",
    value: function() {
      return this.isContainerReady;
    }
  }, {
    key: "getProviderId",
    value: function() {
      return this.providerId;
    }
  }, {
    key: "getConnectionStatus",
    value: function() {
      return this.connectionStatus;
    }
  }, {
    key: "getPendingCallsCount",
    value: function() {
      return this.pendingCalls.size;
    }
  }, {
    key: "getRegisteredServices",
    value: function() {
      return Array.from(this.serviceActions.keys());
    }
  }, {
    key: "requestContainerReady",
    value: function() {
      this.sendToContainer({
        type: "WAITING_CONTAINER_READY",
        providerId: this.providerId
      });
    }
  }]);
}(), J = /* @__PURE__ */ function(r) {
  return r[r.SERVICE_NOT_FOUND = 1001] = "SERVICE_NOT_FOUND", r[r.PERMISSION_DENIED = 1002] = "PERMISSION_DENIED", r[r.DOMAIN_NOT_ALLOWED = 1003] = "DOMAIN_NOT_ALLOWED", r[r.TIMEOUT = 1004] = "TIMEOUT", r[r.NETWORK_ERROR = 1005] = "NETWORK_ERROR", r[r.INVALID_PARAMS = 1006] = "INVALID_PARAMS", r[r.CONCURRENT_LIMIT_EXCEEDED = 1007] = "CONCURRENT_LIMIT_EXCEEDED", r;
}(J || {}), k = null, y = /* @__PURE__ */ new Map();
function ge() {
  var r = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
  return k || (k = new ue(r)), k;
}
function ye(r) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  if (!y.has(r)) {
    var e = new he(r, t);
    y.set(r, e);
  }
  return y.get(r);
}
function pe() {
  return k;
}
function S(r) {
  return r ? y.get(r) || null : y.size > 0 ? Array.from(y.values())[0] : null;
}
function me() {
  var r = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
  return ge(r);
}
function Se() {
  var r;
  return ((r = k) === null || r === void 0 ? void 0 : r.getServiceStatus()) || null;
}
function Ee(r) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  return ye(r, t);
}
function Ce(r, t, e) {
  var n, i = null;
  e ? i = y.get(e) || null : i = S(), (n = i) === null || n === void 0 || n.registerService(r, t);
}
function Re(r, t) {
  var e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, n = arguments.length > 3 ? arguments[3] : void 0, i = null;
  return n ? i = y.get(n) || null : i = S(), i ? i.callAction(r, t, e) : Promise.reject(new Error("ServiceClient not initialized"));
}
function we(r) {
  var t = null;
  return r ? t = y.get(r) || null : t = S(), t ? t.queryServices() : Promise.reject(new Error("ServiceClient not initialized"));
}
function Ie(r) {
  var t, e = null;
  return r ? e = y.get(r) || null : e = S(), ((t = e) === null || t === void 0 ? void 0 : t.isReady()) || !1;
}
function _e(r) {
  var t, e = null;
  return r ? e = y.get(r) || null : e = S(), ((t = e) === null || t === void 0 ? void 0 : t.getConnectionStatus()) || "disconnected";
}
function be(r) {
  var t, e = null;
  return r ? e = y.get(r) || null : e = S(), ((t = e) === null || t === void 0 ? void 0 : t.getPendingCallsCount()) || 0;
}
function Te(r) {
  var t, e = null;
  return r ? e = y.get(r) || null : e = S(), ((t = e) === null || t === void 0 ? void 0 : t.getRegisteredServices()) || [];
}
function Ae(r) {
  var t, e = null;
  return r ? e = y.get(r) || null : e = S(), ((t = e) === null || t === void 0 ? void 0 : t.getProviderId()) || "";
}
function ke(r, t, e) {
  var n, i = null;
  e ? i = y.get(e) || null : i = S(), (n = i) === null || n === void 0 || n.on(r, t);
}
function Me(r, t, e) {
  var n, i = null;
  e ? i = y.get(e) || null : i = S(), (n = i) === null || n === void 0 || n.off(r, t);
}
function Pe(r, t, e) {
  var n, i = null;
  e ? i = y.get(e) || null : i = S(), (n = i) === null || n === void 0 || n.once(r, t);
}
function Ne(r, t) {
  var e, n = null;
  t ? n = y.get(t) || null : n = S(), (e = n) === null || e === void 0 || e.on("serviceChanged", r);
}
function Oe(r, t) {
  var e, n = null;
  t ? n = y.get(t) || null : n = S(), (e = n) === null || e === void 0 || e.off("serviceChanged", r);
}
function Le() {
  k && (k = null), y.clear();
}
function je(r) {
  return W.apply(this, arguments);
}
function W() {
  return W = G(/* @__PURE__ */ M().m(function r(t) {
    var e, n;
    return M().w(function(i) {
      for (; ; ) switch (i.n) {
        case 0:
          if (!t) {
            i.n = 3;
            break;
          }
          if (e = y.get(t), !e) {
            i.n = 2;
            break;
          }
          return i.n = 1, e.destroy();
        case 1:
          y.delete(t);
        case 2:
          i.n = 5;
          break;
        case 3:
          return n = Array.from(y.values()).map(function(a) {
            return a.destroy();
          }), i.n = 4, Promise.all(n);
        case 4:
          y.clear();
        case 5:
          return i.a(2);
      }
    }, r);
  })), W.apply(this, arguments);
}
const De = {
  // Initialization
  createServiceHub: me,
  createServiceClient: Ee,
  getServiceHub: pe,
  getServiceClient: S,
  // ServiceHub
  getServiceStatus: Se,
  // ServiceClient
  registerService: Ce,
  callAction: Re,
  queryServices: we,
  isReady: Ie,
  getConnectionStatus: _e,
  getPendingCallsCount: be,
  getRegisteredServices: Te,
  getProviderId: Ae,
  // Events
  on: ke,
  off: Me,
  once: Pe,
  // Service change listeners
  onServiceChanged: Ne,
  offServiceChanged: Oe,
  // Cleanup
  destroy: Le,
  destroyServiceClient: je,
  // Types and constants
  ErrorCode: J
};
export {
  J as ErrorCode,
  Re as callAction,
  Ee as createServiceClient,
  me as createServiceHub,
  De as default,
  Le as destroy,
  je as destroyServiceClient,
  _e as getConnectionStatus,
  be as getPendingCallsCount,
  Ae as getProviderId,
  Te as getRegisteredServices,
  S as getServiceClient,
  pe as getServiceHub,
  Se as getServiceStatus,
  Ie as isReady,
  Me as off,
  Oe as offServiceChanged,
  ke as on,
  Ne as onServiceChanged,
  Pe as once,
  we as queryServices,
  Ce as registerService
};
//# sourceMappingURL=web-service-hub.es.js.map
